import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import PlanSelectionSection1 from '../components/plan-selection/PlanSelectionSection1';

const meta = {
  title: 'Select a Plan - Ordio.io',
  meta: [],
  link: [],
  style: [],
  script: [
    {
      src: 'js/global-2274.js',
    },
  ],
};

export default function PlanSelection() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <PlanSelectionSection1 />
    </React.Fragment>
  );
}
